module.exports = __webpack_public_path__ + "static/media/img26.fcc0842a.JPG";